import { AnimatedModal, EModalSize, EModalVariants } from '@outdoorsyco/bonfire';

import { useBreakpoint } from '@/hooks/useBreakpoint';
import { IRentalTile } from '@/utility/mapSearchResultToTile';

import css from './QuickPreviewModal.module.css';
import { QuickPreviewModalContent } from './QuickPreviewModalContent';

type TQuickPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  rentalTile: IRentalTile;
  onClickViewListing?: () => void;
};

export const QuickPreviewModal = ({
  isOpen,
  onClose,
  rentalTile,
  onClickViewListing,
}: TQuickPreviewModalProps) => {
  const { isMobile } = useBreakpoint();

  return (
    <AnimatedModal
      isOpen={isOpen}
      className={css.modal}
      size={EModalSize.XLarge}
      variant={isMobile ? EModalVariants.Bottom : undefined}
      withOverlay
      isDismissable
      onClose={() => {
        onClose();
      }}>
      <QuickPreviewModalContent rentalTile={rentalTile} onClickViewListing={onClickViewListing} />
    </AnimatedModal>
  );
};
